<template>
  <div class="text-input-container">
    <div class="input-label-container">
      <label class="input-label">Phone Number</label>
    </div>
    <input
      v-model="displayValue"
      v-bind="$attrs"
      class="input-field"
      aria-label="Phone Number"
      :aria-required="false"
      @blur="isActive = false"
      @focus="isActive = true"
    >
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PhoneNumberInput',
  props: {
    modelValue: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isActive: false
    }
  },
  computed: {
    displayValue: {
      get: function(): string {
        if (this.isActive)
          return this.modelValue

        if (!this.modelValue)
          return '';

        const a = this.modelValue.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
        if (a === null) return ''

        return !a[2] ? a[1] : "(" + a[1] + ") " + a[2] + (a[3] ? "-" + a[3] : "")
      },
      set: function(modifiedValue: string): void {
        let value = ''
        const newValue = parseFloat(modifiedValue.replace(/[^\d]/g, ''))
        if (!isNaN(newValue))
          value = newValue.toString()

        this.$emit('update:modelValue', value)
      }
    }
  }
})
</script>

<style scoped lang="scss">
.text-input-container {
  text-align: left;

  > .input-label-container {

    > .input-label {
      @include input-text-field-label;
    }
  }

  > .input-field {
    @include input-text-field;
  }
}
</style>
